import { useQueryClient } from '@tanstack/react-query'
import {
  bffCrmPracticeHours,
  BffCrmPracticeHoursRetrieveResponse,
  BffCrmPracticeHoursCreateBodyParams,
} from '@fireflyhealth/api'

import { useMutation, useQuery } from '~/shared/hooks/query'
export type PracticeHours = BffCrmPracticeHoursRetrieveResponse
export type WeeklyHoursDay = PracticeHours['weekly_hours'][number]
export type PracticeHoursPayload = BffCrmPracticeHoursCreateBodyParams

const practiceHoursQueryKey = () => bffCrmPracticeHours.retrieveQueryKey()

/**
 * The tenant is derived server-side from the signed-in provider, so neither the query key nor the
 * save payload carries one.
 */
export const usePracticeHours = () =>
  useQuery(
    practiceHoursQueryKey(),
    () => bffCrmPracticeHours.retrieve().then(response => response.data),
    undefined,
    { error: 'Failed to fetch practice hours' },
  )

export const useSavePracticeHours = () => {
  const client = useQueryClient()
  return useMutation(
    (payload: PracticeHoursPayload) =>
      bffCrmPracticeHours.create({ data: payload }).then(response => response.data),
    {
      onSuccess: async () => {
        await client.invalidateQueries({ queryKey: practiceHoursQueryKey() })
      },
    },
    { error: 'Failed to save practice hours', success: 'Practice hours saved' },
  )
}
